import {
  ViewEncapsulation, Component, ChangeDetectionStrategy, Input, Output, EventEmitter
} from '@angular/core';
import { Router } from '@angular/router';

import { userHistoryDetailRoute, userHistoryRoute } from '@user-history/constants/history-routes.constants';
import { ReservationType } from '@user-history/entities/user-history-item';
import { ButtonType } from '@design-system/components/molecules/button/entities/button.types';

@Component({
  selector: 'app-abandoned-reservation-actions',
  templateUrl: './abandoned-reservation-actions.component.html',
  styleUrls: ['./abandoned-reservation-actions.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class AbandonedReservationActionsComponent {

  @Input() itineraryId: string | number;
  @Input() reservationType: ReservationType;
  @Input() userId: string | number;
  @Input() isMobile: boolean;
  @Input() isLoadingCancellation: boolean;

  private enabledAbandonedCancellation = [
    ReservationType.Flight,
    ReservationType.Hotel,
    ReservationType.Auto,
    ReservationType.AirPackage,
    ReservationType.Extra
  ]

  @Output() cancelEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly cancelBtnDsType = ButtonType.Secondary;

  constructor(
    private router: Router
  ) { }

  get enabledCancellation(): boolean {
    return this.enabledAbandonedCancellation.includes(this.reservationType);
  }

  public goToHistoryItem(): void {
    if (!this.isLoadingCancellation) {
      const isValidItineraryData = this.itineraryId && this.reservationType && this.userId;
      if (isValidItineraryData && this.isMobile) {
        this.router.navigate([
          userHistoryRoute, userHistoryDetailRoute, 'validate', this.userId, this.itineraryId, this.reservationType]
        );
      } else if (isValidItineraryData) {
        this.router.navigate([userHistoryRoute, this.userId], {
          queryParams: { detail: this.itineraryId, type: this.reservationType }
        }).catch(() => this.router.navigate(['/']));
      }
    }
  }

  public cancel(): void {
    if (!this.isLoadingCancellation) {
      this.cancelEvent.emit();
    }
  }
}
